import Utility from '@/utils/Utility'

export default {
  name: 'TypeMovies',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    showImages() {
      return this.model.attachments &&
        this.model.attachments.length
    },
    images() {
      return this.model.attachments
    },
  },
}
